import { Component, Inject, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddFeasibilityStudyVm, AddressVm, CheckboxVm, PersonalDetailsVm, TimePreferenceVm } from 'src/app/services/property-matrix/models';
import { GlobalConstants } from 'src/app/common/global-constants';
import { DatePipe } from '@angular/common';
import { GlobalMethods } from 'src/app/common/global-methods';
import { AdditionalServeService } from 'src/app/services/property-matrix/services';

@Component({
  selector: 'app-feasibility-studies-request',
  templateUrl: './feasibility-studies-request.component.html',
  styleUrls: ['../../../../../css/2-modules/_forms.scss']
})

export class FeasibilityStudiesRequestComponent implements OnInit {

  emailPattern: string = GlobalConstants.emailPattern;

  loading: boolean = false;

  investmentTypes: CheckboxVm[] = [
    { id: 1, value: 'Retail', checked: false },
    { id: 2, value: 'Residential', checked: false },
    { id: 3, value: 'Offices', checked: false },
    { id: 4, value: 'Commercial', checked: false },
    { id: 5, value: 'Industrial', checked: false },
  ]

  today: Date = new Date();
  checkDate: CheckboxVm[] = [];

  timePreferences: TimePreferenceVm[] = [
    { date: this.checkDate.find(f => f.id == 1), startTime: '2022-10-12T12:12:11.134Z', endTime: '2022-10-12T12:12:11.134Z' },
    { date: this.checkDate.find(f => f.id == 2), startTime: '2022-10-12T12:12:11.134Z', endTime: '2022-10-12T12:12:11.134Z' },
    { date: this.checkDate.find(f => f.id == 3), startTime: '2022-10-12T12:12:11.134Z', endTime: '2022-10-12T12:12:11.134Z' }
  ]

  personalDetails: PersonalDetailsVm = {
    name: '',
    surname: '',
    landline: '',
    phoneNumber: '',
    alternativeNumber: '',
    emailAddress: '',
    confirmEmail: '',
    emailConfirmed: false,
    id_Number: ''
  }

  propertyDetails: AddressVm = {
    unitNumber: '',
    complexName: '',
    streetNumber: '',
    streetName: '',
    suburb: '',
    city: '',
    propertyDescription: '',
    currentLandUse: ''
  }

  queryBody: AddFeasibilityStudyVm = {
    personalDetails: this.personalDetails,
    propertyDetails: this.propertyDetails,
    investmentType: this.investmentTypes,
    plannedDevelopment: '',
    timePreferenceVMs: this.timePreferences
  }

  constructor(public dialog: MatDialog, private datePipe: DatePipe, private addService: AdditionalServeService) { }
  
  ngOnInit(): void {
    this.checkDate = [
      { id: 1, value: this.datePipe.transform(this.today.setDate(this.today.getDate() + 1), 'yyyy-MM-dd'), checked: false },
      { id: 2, value: this.datePipe.transform(this.today.setDate(this.today.getDate() + 1), 'yyyy-MM-dd'), checked: false },
      { id: 3, value: this.datePipe.transform(this.today.setDate(this.today.getDate() + 1), 'yyyy-MM-dd'), checked: false },
    ]
  }
  emailConfirmed: boolean;
  checkValidation(email: NgModel, confirmEmail: NgModel) {
    this.emailConfirmed = GlobalMethods.checkValidation(email, confirmEmail);
  }

  validateTimePreference(): boolean {
    return (this.checkDate.filter(f => f.checked == true).length == 0);
  }

  submit({ value, valid }: { value: AddFeasibilityStudyVm, valid: boolean }) {
    this.loading = true
    this.queryBody.timePreferenceVMs = this.timePreferences.filter(f => f.date.checked == true);
    this.queryBody.investmentType = this.investmentTypes.filter(f => f.checked == true);
    if (valid && this.emailConfirmed) {
      this.addService.apiV1AdditionalServeCaptureFeasibilityStudyPost$Response({ body: this.queryBody }).pipe()
        .subscribe(Response => {
          this.loading = false
          GlobalMethods.tinySuccessAlert("Saved!", "Your details have been submitted!");
        },
          error => {
            this.loading = false
            GlobalMethods.tinyErrorAlert("Error", "Please check that all mandatory fields are filled in.");
          }
        );
    } else {
      this.loading = false
      GlobalMethods.tinyErrorAlert("Error", "Please check that all mandatory fields are filled in.")
    }
  }

  clicked: boolean = false;
  openDialog(id: number) {
    if (this.clicked == true) {
      this.clicked = false;
      return;
    }
    this.clicked = true;
    if (this.checkDate[id - 1].checked == false) {
      const dialogRef = this.dialog.open(TimePickerDialog, {
        width: '25vw',
        height: '30vh',
        data: { timePreferences: this.timePreferences }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result == null || result.startTime == null || result.endTime == null) {
          GlobalMethods.tinyErrorAlert("Error", "Please select your preferred time");
          this.checkDate[(id - 1)].checked = false;
        } else if (result.startTime > result.endTime) {
          GlobalMethods.tinyErrorAlert("Error", "Make sure your start time is before your end time");
          this.checkDate[(id - 1)].checked = false;
        } else if (result.startTime < "09:00" || result.endTime > "16:00") {
          GlobalMethods.tinyErrorAlert("Error", "Please choose times between 09:00 and 16:00");
          this.checkDate[(id - 1)].checked = false;
        }
        else if (result) {
          this.timePreferences.find(f => f.date == this.checkDate.find(f => f.id == id)).startTime = this.setDateForAPI(id, result.startTime);
          this.timePreferences.find(f => f.date == this.checkDate.find(f => f.id == id)).endTime = this.setDateForAPI(id, result.endTime);
        }
      });
    }
  }

  setDateForAPI(id: number, time: string): string {
    return ((this.timePreferences.find(f => f.date == this.checkDate.find(f => f.id == id)).date).value + 'T' + time + ':00.000Z');
  }
}

@Component({
  selector: 'time-picker-dialog',
  templateUrl: './time-picker-dialog.html'
})
export class TimePickerDialog {

  constructor(public dialogRef: MatDialogRef<TimePickerDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TimePreferenceVm) { }

  closeDialog() {
    if (this.data.startTime == null) { this.dialogRef.close(null) }
    else { this.dialogRef.close(this.data); }
  }
}